export default {
  'userManagement':{
    checkAll: true,//是否全选
    value:"用户管理",
    route:"/userManagement",
    authorizedRoutes:'/userManagement',
    icon:"el-icon-user-solid",
    child: {
      'userManagement-roles-list':{
        checkAll: true,
        value:"角色列表",
        route:"/userManagement/roles/list",
        authorizedRoutes:["/userManagement/roles/list","/userManagement/roles/addRoles",'/userManagement/roles/editRoles'],
        child: {}
      },
      'userManagement-user-list':{
        checkAll: true,
        value:"用户列表",
        route:"/userManagement/user/list",
        authorizedRoutes:["/userManagement/user/list","/userManagement/user/addUsers"],
        child:{}
      },
    },
  },
  'CP':{
    checkAll: true,//是否全选
    value:"CP管理",
    route:"/CP",
    authorizedRoutes:'/CP',
    icon:"el-icon-setting",
    child: {
      'CP-list':{
        checkAll: true,
        value:"CP审核",
        route:"/CP/list",
        authorizedRoutes:'/CP/list',
        child: {},
      },
      'CP-examine':{
        checkAll: true,
        value:"CP列表",
        route:"/CP/examine",
        authorizedRoutes:'/CP/examine',
        child: {},
      },
    },
  },
  'contentManagement':{
    checkAll: true,//是否全选
    value:"内容管理",
    route:"/contentManagement",
    authorizedRoutes:["/contentManagement"],
    icon:"el-icon-edit-outline",
    child: {
      'contentManagement-recommend-list':{
        checkAll: true,
        value:"内容推荐列表",
        route:"/contentManagement/recommend/list",
        authorizedRoutes:["/contentManagement/recommend/list","/contentManagement/recommend/examine"],
        child: {}
      },
      'contentManagement-violation-list':{
        checkAll: true,
        value:"内容违规列表",
        route:"/contentManagement/violation/list",
        authorizedRoutes:"/contentManagement/violation/list",
        child: {}
      },
    },
  },
}